export const USERS_EMPTY = 'USERS_EMPTY'
export const USERS = 'USERS'
export const USERS_SUCCESS = 'USERS_SUCCESS'
export const USERS_FAILURE = 'USERS_FAILURE'

export const USERS_ALL_DATA = 'USERS_ALL_DATA'
export const USERS_SUCCESS_ALL_DATA = 'USERS_SUCCESS_ALL_DATA'
export const USERS_FAILURE_ALL_DATA = 'USERS_FAILURE_ALL_DATA'

export const USERS_ADD = 'USERS_ADD'
export const USERS_ADD_RESET = 'USERS_ADD_RESET'
export const USERS_ADD_SUCCESS = 'USERS_ADD_SUCCESS'
export const USERS_ADD_FAILURE = 'USERS_ADD_FAILURE'

export const USERS_EXISTS = 'USERS_EXISTS'
export const USERS_EXISTS_RESET = 'USERS_EXISTS_RESET'
export const USERS_EXISTS_SUCCESS = 'USERS_EXISTS_SUCCESS'
export const USERS_EXISTS_FAILURE = 'USERS_EXISTS_FAILURE'

export const USERS_INVITATION_ADD = 'USERS_INVITATION_ADD'
export const USERS_INVITATION_ADD_SUCCESS = 'USERS_INVITATION_ADD_SUCCESS'
export const USERS_INVITATION_ADD_FAILURE = 'USERS_INVITATION_ADD_FAILURE'

export const USERS_EDIT = 'USERS_EDIT'
export const USERS_EDIT_SUCCESS = 'USERS_EDIT_SUCCESS'
export const USERS_EDIT_FAILURE = 'USERS_EDIT_FAILURE'
export const USERS_EDIT_SELECT = 'USERS_EDIT_SELECT'
export const USERS_EDIT_UNSET_SELECT = 'USERS_EDIT_UNSET_SELECT'

export const USERS_DELETE = 'USERS_DELETE'
export const USERS_DELETE_SUCCESS = 'USERS_DELETE_SUCCESS'
export const USERS_DELETE_FAILURE = 'USERS_DELETE_FAILURE'

export const USERS_CHANGE_PASSWORD_SELECT = 'USERS_CHANGE_PASSWORD_SELECT'
export const USERS_CHANGE_PASSWORD_UNSET_SELECT = 'USERS_CHANGE_PASSWORD_SELECT'
export const USERS_CHANGE_PASSWORD = 'USERS_CHANGE_PASSWORD'
export const USERS_CHANGE_PASSWORD_SUCCESS = 'USERS_CHANGE_PASSWORD_SUCCESS'
export const USERS_CHANGE_PASSWORD_FAILURE = 'USERS_CHANGE_PASSWORD_FAILURE'

export const APP_DRAWER_ENABLED = 'APP_DRAWER_ENABLED'

export const USERS_EXIST_GROUP = 'USERS_EXIST_GROUP'
export const USERS_EXIST_GROUP_SUCCESS = 'USERS_EXIST_GROUP_SUCCESS'
export const USERS_EXIST_GROUP_FAILURE = 'USERS_EXIST_GROUP_FAILURE'
export const GET_USER_METIONS = 'GET_USER_METIONS'
export const GET_USER_METIONS_SUCCESS = 'GET_USER_METIONS_SUCCESS'
export const GET_USER_METIONS_FAILURE = 'GET_USER_METIONS_FAILURE'
